import PaymentPending from './PaymentPending';

export default PaymentPending;
